module.exports = __webpack_public_path__ + "static/media/csvIcon.513fa20c.png";